<template>
  <div>
    <WrapperDocRef :title="$t('message.refdocs')">
      <template
        v-if="purchase.status == 'approved'"
        #content
      >
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.paymententry')} (${purchase.reference.payments.length})`"
          :links="PELinks"
          :createButtonText="$t('newdocuments.pe')"
          :showCreateButton="(getDebtPurchaseAmount(purchase) > 0 || (getTotal(purchase.orders).net == 0) && purchase.reference.payments == 0) && !disabled"
          @onCreate="handleClickCreatePE"
        />
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.goodsreceipt')} (${purchase.reference.goodsreceipts.length})`"
          :links="GRLinks"
          :createButtonText="$t('newdocuments.gr')"
          :showCreateButton="filterOrdersCanBeReceiptCount > 0 && !disabled"
          @onCreate="handleClickCreateGR"
        />
      </template>
      <template
        v-else
        #content
      >
        -
      </template>
    </WrapperDocRef>

    <div
      id="registerpaymentModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.paymententry') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextPeCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextPeCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <form-paymententry
                v-if="formPE_isReady"
                :po="purchase"
                :amount="getDebtPurchaseAmount(purchase)"
                :validation="trickValidationPayment"
                @submit="onSubmitPayment"/>
              <span v-else>
                {{ $t('message.loading') }}
              </span>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeRegisterPaymentModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!formPE_isReady"
              type="button"
              class="btn btn-web"
              @click="trickValidationPayment++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="goodsreceiptModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.goodsreceipt') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextGrCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextGrCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <form-goodsreceipt
                v-if="formGR_isReady"
                :po="purchase"
                :validation="trickValidationGoodsReceipt"
                @submit="onSubmitGoodsReceipt"/>
              <span v-else>
                {{ $t('message.loading') }}
              </span>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading || !nextGrCode"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeGoodsReceiptModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!formGR_isReady"
              type="button"
              class="btn btn-web"
              @click="trickValidationGoodsReceipt++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading && nextGrCode"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import _ from 'lodash'
import WrapperDocRef from '@/components/combine/WrapperDocRef.vue'
import BaseSectionDocRefLink from '@/components/base/BaseSectionDocRefLink.vue'
import PurchaseService from '@/api/PurchaseService'

export default {
  props: {
    purchase: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WrapperDocRef,
    BaseSectionDocRefLink,
  },
  data () {
    return {
      trickValidationPayment: 0,
      trickValidationGoodsReceipt: 0,

      showFormPE: false,
      showFormGR: false,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      error: 'getError',
      warehouses: 'getWarehouses',
      products: 'getProducts',
      getMainWarehouse: 'getMainWarehouse',
      getMainStock: 'getMainStock',
      nextPeCode: 'getNextPeCode',
      nextGrCode: 'getNextGrCode',
      getWarehouseInfo: 'getWarehouseInfo',
      getPercentageOfPayment: 'getPercentageOfPayment',
      getPaymentStatus: 'getPaymentStatus',
      getGoodsReceiptStatus: 'getGoodsReceiptStatus',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      getPurchaseStatus: 'getPurchaseStatus',
      me: 'getMe',
      isAssignedSkuToStock: 'isAssignedSkuToStock',
      getPRStatus: 'getPRStatus',
    }),
    PELinks() {
      return this.purchase.reference.payments.map((item) => {
        return {
          to: {
            name: 'AccountsPaymentEntryEdit',
            query: {
              pe_id: item.pe_id,
              pe_code: item.pe_code,
            },
          },
          text: item.pe_code,
          status: {
            text: this.getPaymentStatus(item, this.$t).message,
            color: this.getColorFormStatus(this.getPaymentStatus(item, this.$t).status),
            type: 'icon',
          },
          to_appid: 12,
          current_appid: 4,
        }
      })
    },
    GRLinks() {
      return this.purchase.reference.goodsreceipts.map((item) => {
        return {
          to: {
            name: 'GoodsReceiptEdit',
            query: {
              gr_id: item.gr_id,
              gr_code: item.gr_code,
            },
          },
          text: item.gr_code,
          status: {
            text: this.getGoodsReceiptStatus(item, this.$t).message,
            color: this.getColorFormStatus(this.getGoodsReceiptStatus(item, this.$t).status),
            type: 'icon',
          },
          to_appid: 3,
          current_appid: 4,
        }
      })
    },
    formGR_isReady () {
      return this.warehouses.length > 0 && this.showFormGR
    },
    formPE_isReady () {
      return this.showFormPE
    },
    filterOrdersCanBeReceiptCount () {
      let count = 0
      this.purchase.orders.map(order => {
        let productInfo = this.getProductInfoBySkuId(order.sku_id)
        let skuInfo = this.getSku(order.sku_id)
        if (productInfo) {
          if (productInfo.type == 'product' && skuInfo.stocks.length > 0) {
            count++
          }
        }
      })
      return count
    },
  },
  methods: {
    ...mapActions([
      'getWarehouses',
      'getProducts',
      'insertGoodsreceipt',
      'getPurchase',
      'insertPayment',
      'getNextPeCode',
      'getNextGrCode',
      'doneGoodsreceipt',
    ]),
    getSku (sku_id) {
      let product = this.getProductInfoBySkuId(sku_id)
      return product.prices.find(sku => sku.sku_id == sku_id)
    },
    async openRegisterPaymentModal () {
      // set status form
      this.showFormPE = true
      // show modal
      $('#registerpaymentModal').modal('show')
      // get next pe code
      if (!this.nextPeCode) {
        await this.getNextPeCode()
        // finish bar loading
        this.showFinish(this.$Progress)
      }
    },
    closeRegisterPaymentModal () {
      // set status form
      this.showFormPE = false
      // show modal
      $('#registerpaymentModal').modal('hide')
    },
    async openGoodsReceiptModal () {
      // set status form
      this.showFormGR = true
      // show modal
      $('#goodsreceiptModal').modal('show')
      // get next gr code
      if (!this.nextGrCode) {
        // get warehouses
        await this.getWarehouses()
        // get next gr code
        await this.getNextGrCode({
          warehouse_id: this.getMainWarehouse.warehouse_id,
          short_name: this.getMainWarehouse.short_name,
        })
        // finish bar loading
        this.showFinish(this.$Progress)
      }
    },
    closeGoodsReceiptModal () {
      // set status form
      this.showFormGR = false
      // show modal
      $('#goodsreceiptModal').modal('hide')
    },
    async onSubmitPayment (isValid, data) {
      if (!isValid) {
        return false
      }

      let dataSet = {
        'type': 'pay',
        'status': data.status,
        'created_at': this.moment().toISOString(),
        'note': data.note,
        'payment': {
          	'type': data.type,
          	'amount': parseFloat(data.amount),
        },
        'reference': {
          'po_id': this.purchase.po_id,
        },
        'partner': {
          'vendor_id': data.partner.vendor_id ? data.partner.vendor_id : null,
        },
      }

      let res = await this.$store.dispatch('insertPayment', dataSet)

      if (res.success) {
        // call api to get purchase
        let po
        let pr
        const poResponse = await this.$store.dispatch('getPurchase', { po_id: this.purchase.po_id })
        po = poResponse.data.length && poResponse.data[0]

        if (po.ref_purchase_id) {
          const prResponse = await PurchaseService.getSingle({ po_id: po.ref_purchase_id, doc_type: 'pr' })
          pr = prResponse.data.data.length && prResponse.data.data[0]
        }

        let newPayment = res.data.payment

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPayment.pe_code }),
          color: 'success',
          icon: 'cloud',
        })

        // show notify purchase completed
        if (this.getPurchaseStatus(this.purchase, this.$t, this.mixin).status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: po.po_code }),
              color: 'success ',
              icon: 'check',
            })
          }, 500)
        }

        if (pr && this.getPRStatus(pr, pr.reference.purchase_orders.length ? pr.reference.purchase_orders[0] : null, this.$t, this.mixin).status === 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: pr.po_code }),
              color: 'success ',
              icon: 'check',
            })
          }, 1000)
        }

        // finish loading
        this.closeRegisterPaymentModal()
        this.showFinish(this.$Progress)
      }
    },
    async onSubmitGoodsReceipt (isValid, data) {
      if (!isValid) {
        this.notify(this.$vs, {
          text: this.$t('message.notfoundorders'),
          color: 'warning',
          icon: 'warning',
          time: 3000,
        })
        return false
      }

      let warehouseInfo = this.getWarehouseInfo(data.warehouse_id)
      let purchaseOrders = data.orders

      // set dataset to call api
      var goodsreceiptOrders = []
      for (let i in purchaseOrders) {
        let order = purchaseOrders[i]
        let productInfo = this.getProductInfoBySkuId(order.sku_id)
        let skuInfo = this.getSku(order.sku_id)
        let stock = skuInfo.stocks.find(stock => stock.warehouse_id == data.warehouse_id)

        if (stock) {
          const newOrder = {
            'sku_id': order.sku_id,
            'item': order.item,
            'quantity': Number(order.quantity),
            'stock_id': stock.stock_id,
            'warehouse_id': stock.warehouse_id,
            'bin_location_id': order.bin_location_id,
          }
          if (order.use_lot) {
            newOrder.lot_number = {
              'bin_location_id': order.lot.binId,
              'date_product': toISODateString(order.lot.dateProduct),
              'date_expire': toISODateString(order.lot.dateExpire),
              'cost': order.lot.cost,
            }
          }
          if (order.use_serial) {
            newOrder.serial_numbers = order.serials.map((ser) => {
              return {
                'bin_location_id': ser.binId,
                'serial_number': ser.serialNumber,
                'date_product': toISODateString(ser.dateProduct),
                'date_expire': toISODateString(ser.dateExpire),
                'cost': ser.cost,
              }
            })
          }
          goodsreceiptOrders.push(newOrder)
        }
      }

      let dataSet = {
        'orders': goodsreceiptOrders,
        'stockin': {
        		'warehouse_id': warehouseInfo.warehouse_id,
        		'short_name': warehouseInfo.short_name,
        	},
        	'note': data.note,
        	'po_id': this.purchase.po_id,
        	'vendor_id': this.purchase.vendor ? this.purchase.vendor.vendor_id : null,
        	'scheduled_at': data.scheduled_at.toISOString(),
      }

      // call api to insert goodsreceipt
      let res = await this.insertGoodsreceipt(dataSet)

      if (res.success) {
        let goodsreceipt = res.data.goodsreceipt

        // done goodsreceipt if user checked "received"
        if (data.received) {
          let doneOrders = []
          for (let i in res.data.orders) {
            let order = res.data.orders[i]
            let newOrder = {
              'gro_id': order._id,
              'sku_id': order.sku_id,
              'stock_id': order.stock_id,
              'warehouse_id': order.wh_id,
              'done': order.quantity,
              'quantity': order.quantity,
            }
            // add lot numbers
            if (order.lot_number) {
              newOrder.lot_number = {
                'bin_location_id': order.lot_number.bin_location_id,
                'date_product': order.lot_number.date_product ? toISODateString(order.lot_number.date_product) : null,
                'date_expire': order.lot_number.date_expire ? toISODateString(order.lot_number.date_expire) : null,
                'cost': order.lot_number.cost,
              }
            }
            // add serial numbers
            if (order.serial_numbers && order.serial_numbers.length) {
              newOrder.serial_numbers = order.serial_numbers.map((ser) => {
                return {
                  'bin_location_id': ser.bin_location_id,
                  'serial_number': ser.serial_number,
                  'date_product': ser.date_product ? toISODateString(ser.date_product) : null,
                  'date_expire': ser.date_expire ? toISODateString(ser.date_expire) : null,
                  'cost': ser.cost,
                }
              })
            }
            doneOrders.push(newOrder)
          }
          let dataSet_ = {
            'gr_id': goodsreceipt._id,
            'gr_code': goodsreceipt.gr_code,
            // "note": data.note,
            'orders': doneOrders,
            'reference': {
              'po': {
                'id': this.purchase.po_id,
                'code': this.purchase.po_code,
              },
            },
            'respond_by': this.me.user_id,
            'posting_at': new Date().toISOString(),
          }

          let res_ = await this.doneGoodsreceipt(dataSet_)
        }

        // call api to get purchase
        await this.getPurchase({ po_id: this.purchase.po_id })

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: goodsreceipt.gr_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (data.received) {
          let that = this
          // show notify
          setTimeout(() => {
            this.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: goodsreceipt.gr_code }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }

        // finish loading
        this.showFinish(this.$Progress)
        this.closeGoodsReceiptModal()
      }
    },
    handleClickCreatePE() {
      this.openRegisterPaymentModal()
    },
    handleClickCreateGR() {
      this.openGoodsReceiptModal()
    },
  },
  created: async function () {

  },
  mounted: function () {
    // set popup modal
    this.setModal('#registerpaymentModal')
    this.setModal('#goodsreceiptModal')
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/po/include/RefPO.vue